'use strict';

/* eslint no-undef: "off" */
/**
 * buy now api
 */
define('buyNowApi',['baseApiPost'], function (baseApiPost) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return baseApiPost('/rest/V1/xmapi/buynow', params, { setCache: 'buynow', removeCache: ['cart'] });
  };
});
